var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "70px",
    viewBox: "0 0 56 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty_footer",
    transform: "translate(-287.000000, -40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(187.500000, 70.000000) scale(-1, 1) translate(-187.500000, -70.000000) ",
    points: "375 -5.35873429e-13 375 140 0 140 0 -5.35873429e-13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logotype_footer",
    transform: "translate(287.000000, 40.000000)",
    fill: "#302745"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,0 L27,7.992 L37,7.99280576 L37,0 L39,0 L39,18.0133811 L37,18.0133811 L37,10.0071942 L27,10.007 L27,18.0133811 L25,18.0133811 L25,0 L27,0 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,26.1870504 L19,43.9991989 L17,43.9991989 L17,28.7320504 L11,43.9991989 L8,43.9991989 L2,28.7320504 L2,43.9991989 L0,43.9991989 L0,26.1870504 L3,26.1870504 L9.5,42.7270504 L16,26.1870504 L19,26.1870504 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,0 C53.5375661,0 56,2.48014923 56,5.53956835 C56,8.59898746 53.5375661,11.01585 50.5,11.01585 L49.027,11.015 L56,18.0133811 L53,18.0133811 L46.027,11.015 L45,11.015 L45,18.0133811 L43,18.0133811 L43,0 L50.5,0 Z M50.5,2.01438849 L45,2.01438849 L45,9.0647482 L50.5,9.0647482 C52.4329966,9.0647482 54,7.48647142 54,5.53956835 C54,3.59266527 52.4329966,2.01438849 50.5,2.01438849 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,44 L45,28 L45,44 L43,44 L43,26 L46,26 L54,42 L54,26 L56,26 L56,44 L53,44 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,52 L48.909,61 L49.091,61 L54,52 L56,52 L50,63 L50,70 L48,70 L48,63 L42,52 L44,52 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(28.000000, 22.007194) rotate(-90.000000) translate(-28.000000, -22.007194) ",
    points: "26.9928058 -5.99280576 29.0071942 -5.99280576 29.0071942 50.0071942 26.9928058 50.0071942"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(28.000000, 48.007194) rotate(-90.000000) translate(-28.000000, -48.007194) ",
    points: "26.9928058 20.0071942 29.0071942 20.0071942 29.0071942 76.0071942 26.9928058 76.0071942"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo_full.fdafc9fe.svg";
export { ForwardRef as ReactComponent };